import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let BirthdayCalendarOption: LazyOption = createLazyOption(
    {
        key: 'birthdayCalendar',
        titleStringKey: 'optionTitle_birthdayCalendar',
        searchTermsStringKey: 'optionTitle_birthdayCalendar',
        isHidden: () => {
            return !isFeatureEnabled('cal-birthday-settings');
        },
        allowedOptionKeys: ['BirthdayCalendar'],
    },
    lazyFullModule,
    m => m.default
);
export default BirthdayCalendarOption;
